"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const chalk_1 = __importDefault(require("chalk"));
const left_pad_1 = __importDefault(require("left-pad"));
/** Logger Class */
class Logger {
    /** Creates a new logger with the given service name. */
    constructor(serviceName = '', options = {}) {
        this.serviceName = serviceName;
        this.options = Object.assign({
            output: true
        }, options);
        this.time = process.hrtime();
    }
    message(message, color, timed) {
        let m = color(`[${this.timeString()}]`);
        if (this.serviceName !== '') {
            m += color(`[${this.serviceName}]`);
        }
        m += ` ${message}`;
        if (timed) {
            const diff = process.hrtime(this.time);
            m += chalk_1.default.yellow(' +' + ((diff[0] * 1e9 + diff[1]) / 1e9).toLocaleString('en-GB') + 's');
            this.time = process.hrtime();
        }
        return m;
    }
    log(message, timed = false) {
        if (this.options.output)
            console.log(this.message(message, chalk_1.default.green, timed));
    }
    error(message, timed = false) {
        if (this.options.output)
            console.log(this.message(message, chalk_1.default.red, timed));
    }
    timeString() {
        let time = new Date();
        return left_pad_1.default(time.getDate(), 2, '0')
            + '-'
            + left_pad_1.default(time.getMonth(), 2, '0')
            + '-'
            + time.getFullYear()
            + ' '
            + left_pad_1.default(time.getHours(), 2, '0')
            + ':'
            + left_pad_1.default(time.getMinutes(), 2, '0')
            + ':'
            + left_pad_1.default(time.getSeconds(), 2, '0');
    }
}
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map